import { useEffect } from "react";
import { useStateValue } from "../../context/StateValueContext";
import { trackUserSegment } from "../../../contentsquare.config";

export function ContentsquareUserSegment() {
  const [{ user }] = useStateValue();

  const role = user?.role;
  const companyId = user?.companyId;

  useEffect(() => {
    if (!role || !companyId) {
      return;
    }

    trackUserSegment(role, companyId);
  }, [role, companyId]);

  return null;
}
